import React from "react"
import styled, { css } from "styled-components"

import { format } from "date-fns"
import { ko } from "date-fns/locale"

const ProofTimeStamp = ({ date, small }) => {
  return (
    <Wrapper>
      <TimeStampTop small={small}>{`${format(new Date(date), "yyyy. MM. dd (ccc)", {
        locale: ko,
      })}`}</TimeStampTop>
      <TimeStampBottom>
        <Temp
          small={small}
          style={{ marginRight: `${small ? "calc(100vw * (5 /375))" : "calc(100vw * (11 /375))"}` }}
        >{`${format(new Date(date), "hh")}`}</Temp>
        <Temp
          small={small}
          style={{ marginRight: `${small ? "calc(100vw * (3 /375))" : "calc(100vw * (9 /375))"}` }}
        >
          :
        </Temp>
        <Temp
          small={small}
          style={{ marginRight: `${small ? "calc(100vw * (0 /375))" : "calc(100vw * (6 /375))"}` }}
        >{`${format(new Date(date), "mm")}`}</Temp>
        <Temp small={small}>{`${format(new Date(date), "aa")}`}</Temp>
      </TimeStampBottom>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: inherit;
`

const TimeStampTop = styled.div`
  font-family: "Nanum BaReunHiPi";
  font-size: calc(100vw * (22 / 375));
  font-weight: 400;
  line-height: calc(100vw * (25 / 375));
  color: #fff;
  text-shadow: 0px 2px 4px rgba(28, 28, 28, 0.82);
  ${({ small }) =>
    small &&
    css`
      font-size: calc(100vw * (7 / 375));
      line-height: calc(100vw * (8 / 375));
    `}
`

const TimeStampBottom = styled.div`
  display: flex;
`

const Temp = styled.span`
  font-family: "Nanum BaReunHiPi";
  font-size: calc(100vw * (50 / 375));
  line-height: calc(100vw * (57 / 375));
  font-weight: 400;
  color: #fff;
  text-shadow: 0px 2px 4px rgba(28, 28, 28, 0.82);
  ${({ small }) =>
    small &&
    css`
      font-size: calc(100vw * (17 / 375));
      line-height: calc(100vw * (19 / 375));
    `}
`

export default ProofTimeStamp
